// ============================================================
// TONE — EDITABLE CONTENT
// Alles auf dieser Website lässt sich hier an einer Stelle ändern:
// Bio, Releases, Cover, Streaming-Links, Shows, Socials, E-Mails.
// Cover-/Foto-Platzhalter: später einfach `variant` durch ein
// Bild ersetzen (Artwork-Komponente akzeptiert später image-URLs).
// ============================================================

export const CONTENT = {
  artist: "TONE",
  tagline: "EMOTIONAL TECHNO",
  artistLine: "Zwischen Melancholie, Euphorie und purer Energie.",
  base: "WORLDWIDE",

  // ============ BILDER — HIER AUSTAUSCHEN ============
  // Dateien in den Ordner frontend/public/images/ legen und hier den Pfad eintragen,
  // z. B. heroImage: "/images/hero.jpg" — solange null, läuft der abstrakte Platzhalter.
  heroImage: "/images/hero.jpg", // Crowd-Shot aus dem Booth (S/W)
  aboutImage: "/images/about.jpg", // Peace-Portrait (S/W)

  instagram: {
    handle: "@TONIXSVEN",
    url: "https://instagram.com/tonixsven",
  },

  bookingEmail: "booking@tonesound.de",
  pressEmail: "press@tonesound.de",
  infoEmail: "info@tonesound.de",

  // Link zu deinem EPK (Electronic Press Kit) — liegt unter public/epk/
  epkUrl: "/epk/TONE_EPK_2027.pdf",

  // Streaming-Links (Künstler-Profile)
  streaming: [
    { name: "SPOTIFY", url: "https://open.spotify.com/artist/4epsiAN7RX6d3gqW7NQPYG" },
    { name: "APPLE MUSIC", url: "https://music.apple.com/us/artist/tone/1572953709" },
    { name: "SOUNDCLOUD", url: "https://soundcloud.com/tonemusix" },
    { name: "BEATPORT", url: "https://www.beatport.com/de/artist/tone-de/1006517" },
  ],

  // Feature-Bereich (aktuell: bester Remix statt Latest Release)
  latestRelease: {
    eyebrow: "BEST REMIX",
    title: "VERMISSEN",
    subtitle: "TONE REMIX — JUJU & HENNING MAY",
    type: "REMIX",
    date: "2026",
    description:
      "32.000+ Plays auf SoundCloud: TONEs Remix des Juju & Henning May Tracks. Melancholischer Gesang trifft treibenden Techno — ein Remix zum Fühlen und Durchdrehen.",
    variant: "core",
    image: "/images/covers/vermissen-remix.jpg",
    links: [
      { name: "SOUNDCLOUD — JETZT HÖREN", url: "https://soundcloud.com/tonemusix/juju-henning-may-vermissen" },
      { name: "SPOTIFY — ALLE RELEASES", url: "https://open.spotify.com/artist/4epsiAN7RX6d3gqW7NQPYG" },
      { name: "INSTAGRAM — REMIX ANFRAGEN", url: "https://instagram.com/tonixsven" },
    ],
  },

  releases: [
    { title: "IN LOVE", type: "SINGLE", year: "2026", meta: "SINGLE — 2026", variant: "core", image: "/images/covers/in-love.jpg", url: "https://open.spotify.com/album/4bFBgt3bSoescmgrNmkyKY", span: "md:col-span-7" },
    { title: "35 GRAD", type: "EP", year: "2026", meta: "EP — 2026", variant: "horizon", image: "/images/covers/35-grad.jpg", url: "https://open.spotify.com/album/3NARgrnhUrQM2HQE85vVkV", span: "md:col-span-5" },
    { title: "REDLIGHT", type: "EP", year: "2025", meta: "EP — 2025", variant: "beam", image: "/images/covers/redlight.jpg", url: "https://open.spotify.com/album/2QyGUZGu1GowL6f9Rr40BB", span: "md:col-span-5" },
    { title: "STAND BY YOU", type: "SINGLE", year: "2023", meta: "SINGLE — 285K PLAYS", variant: "ember", image: "/images/covers/stand-by-you.jpg", url: "https://open.spotify.com/album/7qKVhbyPjy8xN98QBH0aSO", span: "md:col-span-7" },
  ],

  // Shows kommen aus dem Google Sheet (Tab "Shows") — hier nur Fallback, falls das Sheet offline ist.
  shows: [
    { date: "2026.10.14", event: "KLUB NACHT", city: "BERLIN, DE", tickets: "#" },
    { date: "2026.11.02", event: "SOLARIS OPEN AIR", city: "AMSTERDAM, NL", tickets: "#" },
  ],

  aboutLines: ["FEEL SOMETHING.", "LET GO.", "GO LOUD."],
  aboutBio:
    "TONE übersetzt emotionale Momente in modernen elektronischen Sound — melodisch, treibend, mit großen Drops. Musik zum Fühlen, Loslassen und Durchdrehen.",

  aboutStatement: {
    line: "Du kannst gleichzeitig fühlen und feiern.",
    text: "Emotionaler Techno zwischen Melancholie und Euphorie: Über 285.000 Spotify-Streams auf „Stand by You“, mehr als 32.000 SoundCloud-Plays auf dem „Vermissen“-Remix und eine eigene Playlist-Brand („This Is TONE“). Presse-Material, Tech-Rider und Logo-Dateien gibt's im EPK.",
  },

  visuals: [
    { caption: "OPEN AIR — FOG & LIGHT", variant: "beam", ratio: "aspect-[3/4]", image: "/images/galerie-1.jpg" },
    { caption: "CROWD ENERGY", variant: "ember", ratio: "aspect-[4/3]", image: "/images/galerie-4.jpg" },
    { caption: "STREET / SUNSET", variant: "veil", ratio: "aspect-square", image: "/images/galerie-5.jpg" },
    { caption: "CROWD LOVE", variant: "horizon", ratio: "aspect-[3/4]", image: "/images/galerie-2.jpg" },
    { caption: "ON THE DECKS", variant: "core", ratio: "aspect-[4/5]", image: "/images/galerie-3.jpg" },
    { caption: "CLUB NIGHT — TONE BOOTH", variant: "void", ratio: "aspect-[4/3]", image: "/images/galerie-6.jpg" },
  ],

  // 4 kleine Kacheln in der Instagram-Section (Farbversionen)
  instagramImages: ["/images/insta-1.jpg", "/images/insta-2.jpg", "/images/insta-3.jpg", "/images/insta-4.jpg"],

  marquee: ["EMOTIONAL TECHNO", "MELANCHOLIE", "EUPHORIE", "PURE ENERGIE", "FEEL SOMETHING", "LET GO"],

  inquiryTypes: ["BOOKING — CLUB SHOW", "BOOKING — FESTIVAL", "COLLABORATION / REMIX", "PRESS / MEDIA", "OTHER"],
};
